import 'imagesloaded';

require.ensure(['waypoints-core'], () => {
  const Waypoint = require('waypoints-core');

  const $sections = $('.promo-page__section');
  const $animations = $('.promo-page__animation');

  $animations.each((index, item) => {
    const $animation = $(item);
    $animation.attr('src', $animation.data('src'));
    $animation.imagesLoaded(() => {
      $animation.addClass('has-loaded');
    });
  });

  $sections.each((index, item) => {
    const $section = $(item);

    return new Waypoint({
      element: $section[0],
      handler: (direction) => {
        if (direction !== 'down') {
          return;
        }

        // Animate section.
        $section.addClass('is-visible');
      },
      offset: '75%',
    });
  });
});
